import React, { useState } from 'react'
import { Grid, Typography } from '@material-ui/core'
import { CarouselInputMulti } from '../../../../components'

const DataTime = ({ settings, element, setVal }) => {
    const [state, setState] = useState(settings)

    // const setNewValue = (num, val) => {
    //     if (num === `ST_MIESIAC`) {
    //         setVal({ [num]: val })
    //     } else {
    //         setVal({ [num]: val })
    //     }
    // }

    return (
        <React.Fragment>
            {element === "date" ? <Grid container>
                <Grid item xs={12}>
                    <Typography variant="h3">Ustaw datę (dd-mm-rrrr): </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={2}>
                            <CarouselInputMulti init={state.DZIEN} name={`ST_DZIEN`} min={1} max={31} setVal={setVal} num={`ST_DZIEN`} step={1} />
                        </Grid>
                        <Grid item xs={1}><span style={{ fontSize: "86px", margin: "20px auto 0", display: "block", textAlign: "center" }}>.</span></Grid>
                        <Grid item xs={2}>
                            <CarouselInputMulti init={parseInt(state.MIESIAC)} name={`ST_MIESIAC`} min={1} max={12} setVal={setVal} num={`ST_MIESIAC`} step={1} />
                        </Grid>
                        <Grid item xs={1}><span style={{ fontSize: "86px", margin: "20px auto 0", display: "block", textAlign: "center" }}>.</span></Grid>
                        <Grid item xs={2}>
                            <CarouselInputMulti init={state.ROK} name={`ST_ROK`} min={2020} max={2099} setVal={setVal} num={`ST_ROK`} step={1} />
                        </Grid>
                        <Grid item xs={2}></Grid>
                    </Grid>
                </Grid>
            </Grid> : null}
            {element === "dayweek" ? <Grid container>
                <Grid item xs={12}>
                    <Typography variant="h3">Ustaw dzień tygodnia: </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                    <Grid item xs={3}></Grid>
                        <Grid item xs={6}>
                            <CarouselInputMulti init={state.DZIEN_TYG} name={`DZIEN_TYG`} min={0} max={6} setVal={setVal} num={`DZIEN_TYG`} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid> : null}
            {element === "time" ? <Grid container>
                <Grid item xs={12}>
                    <Typography variant="h3">Ustaw czas (hh:mm:ss): </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={2}>
                            <CarouselInputMulti init={state.GODZINY} name={`ST_GODZINY`} min={0} max={23} setVal={setVal} num={`ST_GODZINY`} />
                        </Grid>
                        <Grid item xs={1}><span style={{ fontSize: "86px", margin: "15px auto 0", display: "block", textAlign: "center" }}>:</span></Grid>
                        <Grid item xs={2}>
                            <CarouselInputMulti init={state.MINUTY} name={`ST_MINUTY`} min={0} max={59} setVal={setVal} num={`ST_MINUTY`} />
                        </Grid>
                        <Grid item xs={1}><span style={{ fontSize: "86px", margin: "15px auto 0", display: "block", textAlign: "center" }}>:</span></Grid>
                        <Grid item xs={2}>
                            <CarouselInputMulti init={state.SEKUNDY} name={`ST_SEKUNDY`} min={0} max={59} setVal={setVal} num={`ST_SEKUNDY`} />
                        </Grid>
                        <Grid item xs={2}></Grid>
                    </Grid>
                </Grid>
            </Grid> : null}
        </React.Fragment>
    )
}

export default DataTime